import React from 'react';
import PropTypes from 'prop-types';
import css from './IconCard.css'

function MeetingTypeCard(props) {
  return (
    <div className={css['container']} onClick={props.onClick} role="button" tabIndex="0">
      <div className={css['card-title']}>
        <span>{props.title}</span>
      </div>
      <img src={props.imageUrl}
           aria-hidden="true"
           className={css['image']}
      />
    </div>
  );
}

MeetingTypeCard.propTypes = {
  title: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired
};

export default MeetingTypeCard;
